import {
  GetClimateSurveyInsightsDocument,
  GetClimateSurveyInsightsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type SurveyCategoryScores =
  GetClimateSurveyInsightsQuery['engagementInsights']['climateSurveyInsightsConnection']['edges'][number]['node']['surveyCategoryScores']

interface Params {
  managerId?: string
}

export const useClimateSurveyInsight = ({ managerId }: Params = {}) => {
  const { loading, data, refetch } = useQuery(GetClimateSurveyInsightsDocument, {
    variables: { managerId },
  })

  const nodes =
    data?.engagementInsights.climateSurveyInsightsConnection.edges?.map((edge) => edge.node) ?? []
  const climateSurveyInsight = nodes[0] ?? null

  return {
    loading,
    climateSurveyInsight,
    refetch,
  }
}
